<template>
	<!--Article -->
	<div class="expertise-landing">
		<section class="" v-in-viewport="">
			<div class="inside">
				<div class="text-center headline-container container-fluid"  v-if="pageData.elements">
			  	 	<h1 class="headline" v-in-viewport=""  v-if="pageData.elements.page_title">{{pageData.elements.page_title.value}}</h1>
						<p class="intro_text" v-in-viewport="{}" v-if="pageData.elements.page_intro">{{pageData.elements.page_intro.value}}</p>
			 	</div>
			</div>
		</section>
		<section class="content-article">
			<div class="inside">
				<div class="container-fluid" v-if="pageData.elements">
					<div class="content-article-body col-lg-9 col-sm-8 col-xs-12">
						<h2 class="title">{{pageData.elements.header_title.value}}</h2>

						<div class="embed-container" v-if="pageData.elements.vimeo_id.value.length">
							<iframe :src="'https://player.vimeo.com/video/'+pageData.elements.vimeo_id.value+'?loop=1&title=0&byline=0&portrait=0&api=1&muted=1&autoplay=1'" width="640" height="360" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>
						</div>

						<div class="mask-image" v-else-if="pageData.elements.thumbnail_image.value.length">
							<img v-lazy="pageData.elements.thumbnail_image.value[0].url" :alt="pageData.elements.thumbnail_image.value[0].name"/>
						</div>


						<div class="description" v-html="pageData.elements.main_content.value"></div>
					</div>
					<div class="content-article-author text-center right-column col-lg-3 col-sm-4 col-xs-12">

						<h4 v-if="pageData.elements.title.value.length != 0">{{pageData.elements.title.value}}</h4>

						<!-- Video -->
						<span class="resources_title" v-if="pageData.elements.vimeo_id_right.value.length"><strong>Video</strong></span>
						<div class="embed-container" v-if="pageData.elements.vimeo_id_right.value.length">
							<iframe :src="'https://player.vimeo.com/video/'+pageData.elements.vimeo_id_right.value+'?loop=1&title=0&byline=0&portrait=0&api=1&muted=1&autoplay=1'" width="640" height="360" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>
						</div>


						<!-- Reources -->
						<div class="related_content" v-if=" pageData.elements.resources.value.length > 0 ">
							<ul>
								<li v-for="res in this.pageData.elements.resources.value">
									<a :href="res.url" :title="res.name" target="_blank">{{res.name}}</a>
								</li>
							</ul>
						</div>

						<div class="related_content" v-if="relatedArticles.length > 0">
							<span class="resources_title" v-if="pageData.elements.vimeo_id_right.value.length"><strong>ARTICLES</strong></span>
								<ul>
								<li v-for="art in relatedArticles">
									<a :href="art.elements.url.value">{{art.elements.header_title.value}}</a>
								</li>
							</ul>
						</div>
					</div>
				</div>
			</div>
		</section>

		<contact :labels="labels"></contact>

	</div>
</template>

<script>
	import apiConnection from '../mixins/apiConnection.js';
	import seoModule from '../mixins/seoModule.js';
	import commons from '../mixins/common.js';
	import MailchimpSubscribe from '../components/newsletter.vue';
	import contactForm from '../components/contact-form.vue';
	//import VueRecaptcha from 'vue-recaptcha';
	//import FileSaver from 'file-saver/FileSaver';

	require('../assets/img/n-arrow.png');

	export default{
		name: 'Expertise',
		data () {
		   return {
		   		pageData:[],
		   		authorData:[],
		   		relatedArticles:[],
		     	articles:[],
		     	thanks:false,
					resources: [],
				/*	journeyForm: {
 			      recaptchaVerified: false,
 			      pleaseTickRecaptchaMessage: '',
 						firstname:'',
 						lastname:'',
 						company: '',
 						email: '',
 						campaign: '',
 						message: '',
 						formSubmitted: false,
 						open: false,
 						label: 'Get Started'
 			   }, */
				 labels : {
 					headline : 'Do you want to learn more?',
 					subheadline: 'We want to hear from you.',
 					buttonLabel: 'GET STARTED'
 				}
		   }
		},
		created(){
			let url = (this.$route.path).split('/');
			this.getExpertise(url[3]);
		},
		mounted () {
			setTimeout(function(){
			    $('.st-sticky-share-buttons').addClass('st-sticky-share-buttons-show')
			},1500);
		},
		methods: {
			/*
			openJourney() {
				var elem = document.getElementById("your-journey");

				if(this.journeyForm.open==false){
					elem.classList.add("opened");
					elem.maxHeight = elem.getElementsByClassName('inner')[0].offsetHeight + 100;
						document.getElementById('openJourney').innerHTML='CLOSE';

					setTimeout(function(){
						if (window.screen.width <= 768) {
							document.getElementById("your-journey").scrollIntoView({block: "start", behavior: "smooth"});
						}
						else {
							document.getElementById("your-journey").scrollIntoView({block: "end", behavior: "smooth"});
						}
						window.onresize = function(event) {
							elem.maxHeight = elem.getElementsByClassName('inner')[0].offsetHeight + 100;
						};
					},300);

				}
				else {
					console.log('s');
					elem.classList.remove("opened");
					elem.maxHeight = elem.getElementsByClassName('inner')[0].offsetHeight + 100;
					document.getElementById('openJourney').innerHTML='GET STARTED';

				}

				this.journeyForm.open =  !this.journeyForm.open;
			},
			markRecaptchaAsVerifiedJourney(response) {
				this.journeyForm.pleaseTickRecaptchaMessage = '';
				this.journeyForm.recaptchaVerified = true;
			},
			markRecaptchaAsVerifiedContact(response) {
			 this.contactForm.pleaseTickRecaptchaMessage = '';
			 this.contactForm.recaptchaVerified = true;
		 },
			resetForm(scope) {
			 this.$validator.pause();

			 if(scope=='contactForm'){
					 this.contactForm.recaptchaVerified = false;
					 this.contactForm.pleaseTickRecaptchaMessage = '';
					 this.contactForm.firstname = '';
					 this.contactForm.lastname = '';
					 this.contactForm.company = '';
					 this.contactForm.email = '';
					 this.contactForm.message = '';
					 this.contactForm.checkBoxSelected = true;
			}

			if(scope=='journeyForm'){
					this.journeyForm.recaptchaVerified = false;
					this.journeyForm.pleaseTickRecaptchaMessage = '';
					this.journeyForm.firstname = '';
					this.journeyForm.lastname = '';
					this.journeyForm.company = '';
					this.journeyForm.email = '';
					this.contactForm.message = '';
		 }

			this.$validator.errors.clear();
			this.$validator.reset();
			document.getElementById(scope).reset();
		},
			validateForm(scope) {
				this.$validator.resume();
				const dict = {
					custom: {
						'Email': {
							required: 'This is a required field.',
							email: 'Please enter a validate email address'
						},
						'Last Name': {
							required: 'This is a required field.',
						},
						'First Name': {
							required: 'This is a required field.',
						},
						'Company': {
							required: 'This is a required field.',
						}
					}
				};
				this.$validator.localize('en', dict);
				this.$validator.validateAll(scope).then((result) => {
					if (result) {
						//Check scope
						var formData = new FormData(document.getElementById(scope));
						var myForm;
						if(scope=='contactForm'){
							if(formData.get('LEADCF102')!==null || formData.get('LEADCF106')!==null || formData.get('LEADCF109')!==null){
								this.contactForm.checkBoxSelected = true
							}
							else {
								this.contactForm.checkBoxSelected = false
								return true;
							}
						}
						if(scope=='contactForm'){
							myForm = this.contactForm;
							if (!this.contactForm.recaptchaVerified) {
								this.contactForm.pleaseTickRecaptchaMessage = 'Please tick recaptcha.';
								return true; // prevent form from submitting
							}

						}

						if(scope=='journeyForm'){
							myForm = this.journeyForm;
							if (!this.journeyForm.recaptchaVerified) {
								this.journeyForm.pleaseTickRecaptchaMessage = 'Please tick recaptcha.';
								return true; // prevent form from submitting
							}
						}


						this.$http.post ( 'https://crm.zoho.com/crm/WebToLeadForm', formData ).then(function (response) {
							// success actions
							if(response.statusText=="OK"){
								myForm.formSubmitted = true;
								this.resetForm(scope);
								console.log('x');

								if(scope=='journeyForm'){
										this.$http.get('/CX2-client.pdf',{responseType: 'arraybuffer'}).then((response) => {
											var newBlob = new Blob([response.data], {type:"application/pdf"})
											FileSaver.saveAs(newBlob, "CX2-client-experience-drives-customer-experience.pdf");
										})
								}
							}
						});

						return false;

					}
				});
			},
			*/
		},
		mixins:[apiConnection, commons, seoModule],
		components:{
			'newsletter':MailchimpSubscribe,
			'contact': contactForm
		},
	}
</script>



// WEBPACK FOOTER //
// Expertise.vue?a31c4688